import { RaThemeOptions } from 'react-admin';

const MLK_PRIMARY_COLOR = '#e2250c';

export const mlkThemeCustomizations: RaThemeOptions = {
  palette: {
    primary: {
      main: MLK_PRIMARY_COLOR,
    },
    secondary: {
      main: MLK_PRIMARY_COLOR,
    },
    info: {
      main: MLK_PRIMARY_COLOR,
    },
    text: {
      secondary: '#444444',
    },
  },
  components: {
    // RaSidebar: {
    //   styleOverrides: {
    //     root: {
    //       backgroundColor: 'white',
    //       '& p': {
    //         color: 'black',
    //       },
    //       '& .MuiPaper-root': {
    //         boxShadow: 'none',
    //       },
    //     },
    //   },
    // },
    // RaSidebarToggleButton: {
    //   styleOverrides: {
    //     root: {
    //       color: '#000000',
    //       marginTop: '10px',
    //     },
    //   },
    // },
    // RaMenuRoot: {
    //   styleOverrides: {
    //     root: {
    //       paddingTop: '20px',
    //     },
    //   },
    // },
    // RaMenuItem: {
    //   styleOverrides: {
    //     root: {
    //       color: '#000000',
    //       padding: 'unset',
    //       marginLeft: '8px',
    //       marginRight: '8px',
    //       '& .RaMenuItem-active': {
    //         marginLeft: 'unset',
    //         paddingLeft: 'unset',
    //         color: MLK_PRIMARY_COLOR,
    //         borderRadius: 'unset',
    //         borderLeft: `2px solid ${MLK_PRIMARY_COLOR}`,
    //         '& span': {
    //           fontWeight: 700,
    //         },
    //       },
    //       '& .RaMenuItem-link': {
    //         paddingLeft: '8px',
    //       },
    //     },
    //   },
    // },
    // RaBreadcrumbItem: {
    //   styleOverrides: {
    //     root: {
    //       color: 'rgba(0, 0, 0, 0.87) !important',
    //     },
    //   },
    // },
    // MuiListItem: {
    //   styleOverrides: {
    //     root: {
    //       width: 'unset',
    //     },
    //   },
    // },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-root': {
            color: MLK_PRIMARY_COLOR,
          },
          '& .MuiPaginationItem-root': {
            color: MLK_PRIMARY_COLOR,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.76)',
          },
        },
        contained: {
          '&:hover': {
            boxShadow: '0 8px 20px rgba(0, 0, 0, 0.4), 0 4px 10px rgba(0, 0, 0, 0.3)',
          },
        },
        disableElevation: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        textColorPrimary: {
          color: '#000000 !important',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          '& .Mui-selected': {
            color: `${MLK_PRIMARY_COLOR} !important`,
            fontWeight: 700,
          },
        },
        vertical: {
          borderLeft: '2px solid transparent',
          '& .Mui-selected': {
            borderLeft: `2px solid ${MLK_PRIMARY_COLOR}`,
          },
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          '&.Mui-completed': {
            color: '#2E7D32',
          },
          '&.Mui-active': {
            color: MLK_PRIMARY_COLOR,
            fontWeight: 600,
          },
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          '&.Mui-active': {
            color: MLK_PRIMARY_COLOR,
          },
          '&.Mui-completed': {
            color: '#2E7D32',
          },
        },
      },
    },
  },
};
